import { useHasRedirectPermissions } from 'gen/client';

export function useTagOwnerPermission(serial: string) {
    const { data, error, isLoading, mutate } = useHasRedirectPermissions(serial, {
        swr: {
            enabled: Boolean(serial),
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    });

    return { data, error, isLoading, isOwner: data?.permission, mutate };
}
